import Video from "./Video";

import { on, off } from "@utils/listener";
import { limit } from "@utils/math";

class VideoScrubber extends Video {

  init() {
    this._duration = 0;
    this._ready = false;
    this._scrub = 0;

    this._onMetaDataLoaded = this._onMetaDataLoaded.bind(this);
    this._onDurationChange = this._onDurationChange.bind(this);

    super.init();
  }
  destroy() {
    super.destroy();

    this._duration = null;
    this._ready = null;
    this._scrub = null;

    this._onMetaDataLoaded = null;
    this._onDurationChange = null;
  }

  scrub(percentage) {
    // set limit between [0, 1]
    percentage = limit(0, 1, percentage);

    // make sure value as changed
    if( this._scrub === percentage ) return;
    this._scrub = percentage;

    // if video is not ready, stop here
    if( !this._ready ) return;

    // move playhead if now on low power mode
    if( !this._powerModeLow ) this.el.currentTime = this._duration * this._scrub;
  }

  _bindEvents() {
    on(this.el, 'loadedmetadata', this._onMetaDataLoaded);
    on(this.el, 'durationchange', this._onDurationChange);

    super._bindEvents();
    this._checkReadyness();
  }
  _unbindEvents() {
    super._unbindEvents();

    off(this.el, 'loadedmetadata', this._onMetaDataLoaded);
    off(this.el, 'durationchange', this._onDurationChange);
  }

  _onMetaDataLoaded() { this._checkReadyness(); }
  _onDurationChange() { this._checkReadyness(); }
  _checkReadyness() {
    // if video is already ready, stop here
    if( this._ready ) return;

    if( this.el.readyState > 0 ) {
      this._duration = this.el.duration;
      this._ready = true;

      // move playhead if not on low power mode
      if( !this._powerModeLow ) this.el.currentTime = this._duration * this._scrub;
    } else {
      this._ready = false;
    }
  }
}

export default VideoScrubber;
